/**
 * Help texts of the plan-purchase preview (frontend standard §6: what it
 * means, which direction is good, a range only when there is a defensible
 * one). The page is English, so the help is English. Kept in one place so
 * the wording is easy to edit.
 */
export const PURCHASE_HELP = {
  fee: 'The price of one month of the new plan. It is the same whether you pay it from your balances or by card.',
  proration:
    'When you switch plans, the days of your current plan you have not used yet (whole days, today counts as used) are credited to your credit balance before paying for the new plan. Higher is better for you; it is zero if the old plan was not paid or has no days left.',
  balanceCover:
    'The part of the price taken from your balances, in this order: USDT, then USDC, then credit (1 unit = 1 USD). The more is covered here, the less is charged to your card.',
  card: 'What is left to pay by card after your balances. 0.00 means your balances cover the whole price and no card is needed.',
  creditBefore: 'Your credit balance now, including the credit for unused days when you switch plans.',
  creditAfter:
    'Your credit balance after this payment. The monthly usage fee is taken from this balance, so it should stay at least as high as the next usage fee estimate below.',
  nextFee:
    'An estimate of the next monthly usage fee, taken from your credit on the 1st of next month: the fee for your bot trades so far this month. It can only grow until the month ends, so treat it as a minimum. Compare it with your credit after this payment; if your credit is negative after the 7th, the bot is stopped.',
} as const
